export const chutesModels = {
    id: "chutes",
    name: "Chutes",
    api: "https://llm.chutes.ai/v1",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://llm.chutes.ai/v1/models",
    env: ["CHUTES_API_KEY"],
    models: {
        "meituan-longcat/LongCat-Flash-Chat-FP8": {
            id: "meituan-longcat/LongCat-Flash-Chat-FP8",
            name: "LongCat Flash Chat FP8",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-09-10",
            last_updated: "2025-09-10",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.25,
                output: 1,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "deepseek-ai/DeepSeek-R1-Distill-Llama-70B": {
            id: "deepseek-ai/DeepSeek-R1-Distill-Llama-70B",
            name: "DeepSeek R1 Distill Llama 70B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: false,
            knowledge: "2024-10",
            release_date: "2025-01-23",
            last_updated: "2025-01-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.03,
                output: 0.14,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "deepseek-ai/DeepSeek-V3.1": {
            id: "deepseek-ai/DeepSeek-V3.1",
            name: "DeepSeek V3.1",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-21",
            last_updated: "2025-08-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.2,
                output: 0.8,
            },
            limit: {
                context: 163840,
                output: 163840,
            },
        },
        "deepseek-ai/DeepSeek-R1-0528-Qwen3-8B": {
            id: "deepseek-ai/DeepSeek-R1-0528-Qwen3-8B",
            name: "DeepSeek R1 0528 Qwen3 8B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-05-29",
            last_updated: "2025-05-29",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.02,
                output: 0.07,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "deepseek-ai/DeepSeek-V3.1:THINKING": {
            id: "deepseek-ai/DeepSeek-V3.1:THINKING",
            name: "DeepSeek V3.1 Reasoning",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-21",
            last_updated: "2025-08-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.2,
                output: 0.8,
            },
            limit: {
                context: 163840,
                output: 163840,
            },
        },
        "deepseek-ai/DeepSeek-V3-0324": {
            id: "deepseek-ai/DeepSeek-V3-0324",
            name: "DeepSeek V3 (0324)",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-01",
            last_updated: "2025-08-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.18,
                output: 0.72,
            },
            limit: {
                context: 75000,
                output: 163840,
            },
        },
        "deepseek-ai/DeepSeek-R1-0528": {
            id: "deepseek-ai/DeepSeek-R1-0528",
            name: "DeepSeek R1 (0528)",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-01",
            last_updated: "2025-08-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.18,
                output: 0.72,
            },
            limit: {
                context: 75000,
                output: 163840,
            },
        },
        "openai/gpt-oss-120b": {
            id: "openai/gpt-oss-120b",
            name: "GPT OSS 120B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.1,
                output: 0.41,
            },
            limit: {
                context: 131072,
                output: 32768,
            },
        },
        "chutesai/Devstral-Small-2505": {
            id: "chutesai/Devstral-Small-2505",
            name: "Devstral Small (2505)",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-05-21",
            last_updated: "2025-05-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.02,
                output: 0.08,
            },
            limit: {
                context: 32768,
                output: 32768,
            },
        },
        "chutesai/Mistral-Small-3.2-24B-Instruct-2506": {
            id: "chutesai/Mistral-Small-3.2-24B-Instruct-2506",
            name: "Mistral Small 3.2 24B Instruct (2506)",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-06-20",
            last_updated: "2025-06-20",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.02,
                output: 0.08,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "Qwen/Qwen3-235B-A22B-Thinking-2507": {
            id: "Qwen/Qwen3-235B-A22B-Thinking-2507",
            name: "Qwen3-235B-A22B-Thinking-2507",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-25",
            last_updated: "2025-07-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.078,
                output: 0.312,
            },
            limit: {
                context: 262144,
                output: 262144,
            },
        },
        "Qwen/Qwen3-30B-A3B-Instruct-2507": {
            id: "Qwen/Qwen3-30B-A3B-Instruct-2507",
            name: "Qwen3 30B A3B Instruct 2507",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-25",
            last_updated: "2025-07-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.05,
                output: 0.2,
            },
            limit: {
                context: 262144,
                output: 262144,
            },
        },
        "Qwen/Qwen3-30B-A3B": {
            id: "Qwen/Qwen3-30B-A3B",
            name: "Qwen3 30B A3B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-04-28",
            last_updated: "2025-04-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.02,
                output: 0.08,
            },
            limit: {
                context: 40960,
                output: 40960,
            },
        },
        "Qwen/Qwen3-235B-A22B-Instruct-2507": {
            id: "Qwen/Qwen3-235B-A22B-Instruct-2507",
            name: "Qwen3 235B A22B Instruct 2507",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-04-28",
            last_updated: "2025-07-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.078,
                output: 0.312,
            },
            limit: {
                context: 262144,
                output: 131072,
            },
        },
        "Qwen/Qwen3-Coder-30B-A3B-Instruct": {
            id: "Qwen/Qwen3-Coder-30B-A3B-Instruct",
            name: "Qwen3 Coder 30B A3B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-25",
            last_updated: "2025-07-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 262144,
                output: 262144,
            },
        },
        "Qwen/Qwen3-Coder-480B-A35B-Instruct-FP8": {
            id: "Qwen/Qwen3-Coder-480B-A35B-Instruct-FP8",
            name: "Qwen3 Coder 480B A35B Instruct (FP8)",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-01",
            last_updated: "2025-08-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.2,
                output: 0.8,
            },
            limit: {
                context: 262144,
                output: 262144,
            },
        },
        "zai-org/GLM-4.5-FP8": {
            id: "zai-org/GLM-4.5-FP8",
            name: "GLM 4.5 FP8",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-28",
            last_updated: "2025-07-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "zai-org/GLM-4.5-Air": {
            id: "zai-org/GLM-4.5-Air",
            name: "GLM 4.5 Air",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-28",
            last_updated: "2025-07-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
            },
            limit: {
                context: 131072,
                output: 98304,
            },
        },
        "tngtech/DeepSeek-TNG-R1T2-Chimera": {
            id: "tngtech/DeepSeek-TNG-R1T2-Chimera",
            name: "DeepSeek TNG R1T2 Chimera",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: false,
            knowledge: "2025-07",
            release_date: "2025-07-08",
            last_updated: "2025-07-08",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 0.8,
            },
            limit: {
                context: 163840,
                output: 163840,
            },
        },
        "tngtech/DeepSeek-R1T-Chimera": {
            id: "tngtech/DeepSeek-R1T-Chimera",
            name: "DeepSeek R1T Chimera",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: false,
            knowledge: "2025-04",
            release_date: "2025-04-26",
            last_updated: "2025-04-26",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.18,
                output: 0.72,
            },
            limit: {
                context: 163840,
                output: 163840,
            },
        },
        "moonshotai/Kimi-K2-Instruct-75k": {
            id: "moonshotai/Kimi-K2-Instruct-75k",
            name: "Kimi K2 Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-01",
            last_updated: "2025-08-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.15,
                output: 0.59,
            },
            limit: {
                context: 75000,
                output: 75000,
            },
        },
        "moonshotai/Kimi-VL-A3B-Thinking": {
            id: "moonshotai/Kimi-VL-A3B-Thinking",
            name: "Kimi VL A3B Thinking",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2024-12-01",
            last_updated: "2024-12-01",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.02499,
                output: 0.100008,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "moonshotai/Kimi-K2-Instruct-0905": {
            id: "moonshotai/Kimi-K2-Instruct-0905",
            name: "Kimi K2 Instruct 0905",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-09-05",
            last_updated: "2024-09-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.296176,
                output: 1.18528,
            },
            limit: {
                context: 262144,
                output: 262144,
            },
        },
        "moonshotai/Kimi-Dev-72B": {
            id: "moonshotai/Kimi-Dev-72B",
            name: "Kimi Dev 72B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2024-12-01",
            last_updated: "2024-12-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.06664,
                output: 0.266688,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
    },
};
export default chutesModels;
//# sourceMappingURL=chutes.js.map